import { FreeSpinsSyncFailure } from "@/v2/types/FreeSpinsSync/FreeSpinsSyncResult.interface";

/** The skins that failed as a whole, without reaching any game. */
export const getFailedSkins = (failures: FreeSpinsSyncFailure[]): number[] =>
  Array.from(
    new Set(
      failures
        .filter(({ gameId, gameCode }) => gameId === undefined && gameCode === undefined)
        .map(({ skinId }) => skinId),
    ),
  );
